var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overtime_search" }, [
    _vm.searchParam.searchType !== "0"
      ? _c(
          "div",
          { staticClass: "search_box" },
          [
            _c("el-input", {
              attrs: {
                placeholder: "请搜索档案编号/姓名/工号",
                "prefix-icon": "el-icon-search",
                clearable: ""
              },
              on: {
                input: function($event) {
                  return _vm.searchInit()
                }
              },
              model: {
                value: _vm.searchParam.searchContent,
                callback: function($$v) {
                  _vm.$set(_vm.searchParam, "searchContent", $$v)
                },
                expression: "searchParam.searchContent"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "clear",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_vm._v("取消")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "column",
          "align-items": "stretch",
          "flex-grow": "1",
          "flex-shrink": "1",
          height: "10px"
        }
      },
      [
        _vm.resultShowList.length
          ? _c(
              "div",
              {
                staticClass: "search_content",
                on: { scroll: _vm.handleScroll }
              },
              _vm._l(_vm.resultShowList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index + "search",
                    staticClass: "search_item",
                    on: {
                      click: function($event) {
                        return _vm.selectItem(item)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: item.headImg
                          ? item.headImg
                          : "images/pc/emotion/default_person_82_82.png?v=1.0",
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _c("div", { staticClass: "person" }, [
                        _c(
                          "div",
                          {
                            staticClass: "name",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.highlightHTML(item.personName)
                              )
                            }
                          },
                          [_vm._v(_vm._s(item.personName))]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("(")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "number",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.highlightHTML(item.personNumber)
                              )
                            }
                          },
                          [_vm._v(_vm._s(item.personNumber))]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v(")")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "department" }, [
                        _vm._v(_vm._s(item.adminorgName))
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.resultShowList.length && !_vm.searchParam.searchContent
          ? _c("div", { staticClass: "noData" }, [
              _c("img", { attrs: { src: _vm.searchImgUrl, alt: "" } }),
              _c("span", [_vm._v("请输入关键词进行搜索")])
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.resultShowList.length && _vm.searchParam.searchContent
          ? _c("div", { staticClass: "noData" }, [
              _c("img", { attrs: { src: _vm.noDataImgUrl, alt: "" } }),
              _c("span", [_vm._v("暂无数据")])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }